import { GtmApi } from './gtm.api';

const gtmApi = new GtmApi();

export { gtmApi };
